import {makeContext} from '../MakeContext';
import {FilterJSONOptions, JSONNode} from './util/filterJSON';

type EventData = {
  projectName: string;
  entityName: string;
  userID: string;
};

export type SearchableJSONTreeProps = {
  json?: JSONNode; // Data to render
  rootKeyLabel?: string; // Label for the root key; defaults to "Root"
  filterOptions?: FilterJSONOptions;
  // TODO: re-enable ignoreUnderscoreKeys
  ignoreUnderscoreKeys?: boolean; // Ignore keys starting with "_"; defaults to false
  // TODO: re-enable viewRawData
  viewRawData?: () => void;
  // TODO: i don't think we need this any more, but make sure
  stringifyJsonValue?: boolean; // Call JSON.stringify on values (wraps strings in quotation marks)
  // used for copy analytics
  eventData: EventData;
};

const {
  Provider: SearchableJSONTreePropsProvider,
  hook: useSearchableJSONTreePropsContext,
} = makeContext<SearchableJSONTreeProps>({
  contextType: 'SearchableJSONTreeProps',
});
export {SearchableJSONTreePropsProvider, useSearchableJSONTreePropsContext};
